/*
 *
 * ConnectionManager actions
 *
 */

import * as constants from './constants';

export function serverConnect(auth, remember, connection) {
  return {
    type: constants.CONNECT,
    auth,
    remember,
    connection,
  };
}

export function serverConnectSuccess(bearerToken) {
  return {
    type: constants.CONNECT_SUCCESS,
    bearerToken,
  };
}

export function serverConnectError(error) {
  return {
    type: constants.CONNECT_ERROR,
    error,
  };
}

export function serverDisconnect() {
  return {
    type: constants.DISCONNECT,
  };
}

export function serverRequestError(error) {
  return {
    type: constants.REQUEST_ERROR,
    error,
  };
}

export function commandAuthorPluginGet(pluginId, version, onSuccess) {
  return {
    type: constants.COMMAND_AUTHOR_PLUGIN_GET,
    pluginId,
    version,
    onSuccess,
  };
}

export function commandIamSubscriptionUserList() {
  return {
    type: constants.COMMAND_IAM_SUBSCRIPTION_USER_LIST,
  };
}

export function commandIamSubscriptionTeamList() {
  return {
    type: constants.COMMAND_IAM_SUBSCRIPTION_TEAM_LIST,
  };
}

export function commandAuthorPluginList({ pluginType, pluginFilters }) {
  return {
    type: constants.COMMAND_AUTHOR_PLUGIN_LIST,
    payload: {
      pluginType,
      pluginFilters,
    },
  };
}

export function commandAuthorPluginVersionDelete(pluginId, version) {
  return {
    type: constants.COMMAND_AUTHOR_PLUGIN_VERSION_DELETE,
    pluginId,
    version,
  };
}

export function commandAuthorPluginVersionUnpublish(pluginId, major, minor, patch) {
  return {
    type: constants.COMMAND_AUTHOR_PLUGIN_VERSION_UNPUBLISH,
    pluginId,
    major,
    minor,
    patch,
  };
}

export function commandWorkspacePluginList() {
  return {
    type: constants.COMMAND_WORKSPACE_PLUGIN_LIST,
  };
}

export function commandWorkspacePluginVersionList(pluginId) {
  return {
    type: constants.COMMAND_WORKSPACE_PLUGIN_VERSION_LIST,
    pluginId,
  };
}

export function commandWorkspacePluginCreate(name, pluginType) {
  return {
    type: constants.COMMAND_WORKSPACE_PLUGIN_CREATE,
    name,
    pluginType,
  };
}

export function commandWorkspacePluginDetails(pluginId, version) {
  return {
    type: constants.COMMAND_WORKSPACE_PLUGIN_DETAILS,
    pluginId,
    version,
  };
}

export function commandWorkspacePluginUpdate(pluginId, publishMode) {
  return {
    type: constants.COMMAND_WORKSPACE_PLUGIN_UPDATE,
    pluginId,
    publishMode,
  };
}

export function commandWorkspacePluginCollaboratorSummary(pluginId) {
  return {
    type: constants.COMMAND_WORKSPACE_PLUGIN_COLLABORATOR_SUMMARY,
    pluginId,
  };
}

export function commandWorkspacePluginPermissionGrant(accountOrTeamId, collaboratorType, pluginId, permissionLevel) {
  return {
    type: constants.COMMAND_WORKSPACE_PLUGIN_PERMISSION_GRANT,
    accountOrTeamId,
    collaboratorType,
    pluginId,
    permissionLevel,
  };
}

export function commandWorkspacePluginPermissionRevoke(accountOrTeamId, collaboratorType, pluginId) {
  return {
    type: constants.COMMAND_WORKSPACE_PLUGIN_PERMISSION_REVOKE,
    accountOrTeamId,
    collaboratorType,
    pluginId,
  };
}

export function commandWorkspaceCohortList() {
  return {
    type: constants.COMMAND_WORKSPACE_COHORT_LIST,
  };
}

export function commandWorkspaceCohort(cohortId) {
  return {
    type: constants.COMMAND_WORKSPACE_COHORT,
    cohortId,
  };
}

export function commandWorkspaceCohortCollaboratorsSummary(cohortId) {
  return {
    type: constants.COMMAND_WORKSPACE_COHORT_COLLABORATOR_SUMMARY,
    cohortId,
  };
}

export function commandWorkspaceCohortCreate(cohort) {
  return {
    type: constants.COMMAND_WORKSPACE_COHORT_CREATE,
    cohort,
  };
}

export function commandGrantPermissionOnCohort(accountOrTeamIds, collaboratorType, cohortId, permissionLevel) {
  return {
    type: constants.COMMAND_GRANT_PERMISSION_ON_COHORT,
    accountOrTeamIds,
    collaboratorType,
    cohortId,
    permissionLevel,
  };
}

export function commandRevokePermissionOnCohort(accountOrTeamId, collaboratorType, cohortId) {
  return {
    type: constants.COMMAND_REVOKE_PERMISSION_ON_COHORT,
    accountOrTeamId,
    collaboratorType,
    cohortId,
  };
}

export function commandWorkspaceCohortEnrollmentsList(cohortId) {
  return {
    type: constants.COMMAND_WORKSPACE_COHORT_ENROLLMENTS_LIST,
    cohortId,
  };
}

export function commandWorkspaceActivityPublish(activityId, cohortId, deploymentId) {
  return {
    type: constants.COMMAND_WORKSPACE_ACTIVITY_PUBLISH,
    activityId,
    cohortId,
    deploymentId,
  };
}

export function commandProjectActivityPublish(activityId, cohortId, deploymentId, lockPluginVersionEnabled, supportOnDemandEnabled, scorable, forceUpdateAssessments, addToLibrary) {
  return {
    type: constants.COMMAND_PROJECT_ACTIVITY_PUBLISH,
    activityId,
    cohortId,
    deploymentId,
    lockPluginVersionEnabled,
    supportOnDemandEnabled,
    scorable,
    forceUpdateAssessments,
    addToLibrary,
  };
}

export function commandWorkspaceDeploymentsList(cohortId) {
  return {
    type: constants.COMMAND_WORKSPACE_DEPLOYMENT_LIST,
    cohortId,
  };
}

export function commandWorkspaceAccountCreate(account, meta) {
  return {
    type: constants.COMMAND_WORKSPACE_ACCOUNT_CREATE,
    account,
    meta,
  };
}

export function commandIamTeamCreate(team, meta = {}) {
  return {
    type: constants.COMMAND_IAM_TEAM_CREATE,
    team,
    meta,
  };
}

export function commandIamTeamList() {
  return {
    type: constants.COMMAND_IAM_TEAM_LIST,
  };
}

export function commandWorkspaceCohortArchive(cohortId) {
  return {
    type: constants.COMMAND_WORKSPACE_COHORT_ARCHIVE,
    cohortId,
  };
}

export function commandWorkspaceAccountsList() {
  return {
    type: constants.COMMAND_WORKSPACE_ACCOUNTS_LIST,
  };
}

export function commandIamAccessRequestList(status) {
  return {
    type: constants.COMMAND_IAM_ACCESS_REQUEST_LIST,
    status,
  };
}

export function commandWorkspaceWorkspacesList() {
  return {
    type: constants.COMMAND_WORKSPACE_WORKSPACES_LIST,
  };
}

export function commandWorkspacePublicationsList() {
  return {
    type: constants.COMMAND_WORKSPACE_PUBLICATIONS_LIST,
  };
}

export function commandIamTeamAccountSummary(teamId) {
  return {
    type: constants.COMMAND_IAM_TEAM_ACCOUNT_SUMMARY,
    teamId,
  };
}

export function commandGrantPermissionOnTeam(accountId, collaboratorType, teamId, permissionLevel) {
  return {
    type: constants.COMMAND_GRANT_PERMISSION_ON_TEAM,
    accountId,
    teamId,
    permissionLevel,
  };
}

export function commandRevokePermissionOnTeam(accountIds, teamId) {
  return {
    type: constants.COMMAND_REVOKE_PERMISSION_ON_TEAM,
    accountIds,
    teamId,
  };
}

export function commandWorkspaceCreate(workspace, meta) {
  return {
    type: constants.COMMAND_WORKSPACE_CREATE,
    workspace,
    meta,
  };
}

export function commandWorkspaceCollaboratorSummary(workspaceId) {
  return {
    type: constants.COMMAND_WORKSPACE_COLLABORATOR_SUMMARY,
    workspaceId,
  };
}

export function commandWorkspaceGrantPermission(accountOrTeamIds, collaboratorType, workspaceId, permissionLevel) {
  return {
    type: constants.COMMAND_WORKSPACE_GRANT_PERMISSION,
    accountOrTeamIds: [accountOrTeamIds],
    collaboratorType,
    workspaceId,
    permissionLevel,
  };
}

export function commandWorkspaceRevokePermission(workspaceId, accountOrTeamId, collaboratorType) {
  return {
    type: constants.COMMAND_WORKSPACE_REVOKE_PERMISSION,
    workspaceId,
    accountOrTeamId,
    collaboratorType,
  };
}

export function commandWorkspaceCohortAccountEnroll(accountId, cohortId) {
  return {
    type: constants.COMMAND_WORKSPACE_COHORT_ACCOUNT_ENROLL,
    accountId,
    cohortId,
  };
}

export function commandWorkspaceCohortChange(cohort) {
  return {
    type: constants.COMMAND_WORKSPACE_COHORT_CHANGE,
    cohort,
  };
}

export function commandWorkspaceCoursewareMetaInfoGet(elementId, elementType, key) {
  return {
    type: constants.COMMAND_WORKSPACE_COURSEWARE_META_INFO_GET,
    elementId,
    elementType,
    key,
  };
}

export function commandWorkspaceCoursewareMetaInfoSet(elementId, elementType, key, value) {
  return {
    type: constants.COMMAND_WORKSPACE_COURSEWARE_META_INFO_SET,
    elementId,
    elementType,
    key,
    value,
  };
}

export function commandWorkspacePluginDelete(pluginId) {
  return {
    type: constants.COMMAND_WORKSPACE_PLUGIN_DELETE,
    pluginId,
  };
}

export function commandWorkspaceProjectList(workspaceId) {
  return {
    type: constants.COMMAND_WORKSPACE_PROJECT_LIST,
    workspaceId,
  };
}

export function commandWorkspaceProjectCreate(project, workspaceId) {
  return {
    type: constants.COMMAND_WORKSPACE_PROJECT_CREATE,
    project,
    workspaceId,
  };
}

export function commandWorkspaceProjectIngestList(projectId) {
  return {
    type: constants.COMMAND_WORKSPACE_PROJECT_INGEST_LIST,
    projectId,
  };
}

export function commandWorkspaceProjectIngestGet(ingestionId) {
  return {
    type: constants.COMMAND_WORKSPACE_PROJECT_INGEST_GET,
    ingestionId,
  };
}
